import { Directive, DirectiveBinding } from 'vue'

interface FocusDirectiveElement extends HTMLInputElement {
  value: string
}

const focusDirective: Directive<FocusDirectiveElement> = {
  mounted: (
    el: FocusDirectiveElement,
    { value, modifiers }: DirectiveBinding<boolean | number | undefined>
  ) => {
    if (value !== false && value !== 0 && document.activeElement !== el) {
      el.focus()
    }
    if (modifiers.end) {
      el.selectionStart = el.selectionEnd = el.value.length
    }
  },
  updated: (
    el: FocusDirectiveElement,
    { value, oldValue }: DirectiveBinding<boolean | number | undefined>
  ) => {
    if (value !== oldValue && value && document.activeElement !== el) {
      el.focus()
    }
  },
}

export default focusDirective
